/**
 * @copyright @2022 Techechelons Infosolutions Pvt. Ltd. All rights reserved.
 * @description Page to create routing from all the routes.
 * --------------------------------------------------------------------
 * Creation Details
 * @author Naishad Vaishnav
 * Date Created: 17/Nov/2022
 * FDO Ref:
 * TDO Ref:
 * RTM Ref:
 * Test Case Ref:
 */

// ----------------------------------------------------------------------

/* Imports */
import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

/* Relative Imports */
import LoadingScreen from 'components/LoadingScreen';

/* Local Imports */
import RootRoutes from './rootRoutes';
import AuthRoutes from './authRoutes';
import AdminDashboardRoutes from './adminDashboardRoutes';

// ----------------------------------------------------------------------
/* Merge Routes */
const routes = [...RootRoutes, ...AuthRoutes, ...AdminDashboardRoutes];

/**
 * Create routing with the routes
 *
 * @return {JSX.Element}
 */
function Routing() {
  const content = useRoutes(routes);
  return <Suspense fallback={<LoadingScreen />}>{content}</Suspense>;
}

export default Routing;
